/* Reviews Carousel — scroll-snap track + arrow paging + video lightbox */
(function () {
  'use strict';

  function initCarousel(section) {
    var track = section.querySelector('[data-rc-track]');
    var prev = section.querySelector('[data-rc-prev]');
    var next = section.querySelector('[data-rc-next]');
    if (!track || !prev || !next) return;

    function tileStep() {
      var firstTile = track.querySelector('.rc-tile');
      if (!firstTile) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || '16', 10) || 16;
      return firstTile.offsetWidth + gap;
    }

    function updateNavState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      next.toggleAttribute('disabled', track.scrollLeft >= maxScroll);
    }

    prev.addEventListener('click', function () {
      var perView = parseInt(getComputedStyle(track).getPropertyValue('--rc-tiles-per-view'), 10) || 1;
      track.scrollBy({ left: -tileStep() * Math.max(1, perView - 1), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      var perView = parseInt(getComputedStyle(track).getPropertyValue('--rc-tiles-per-view'), 10) || 1;
      track.scrollBy({ left: tileStep() * Math.max(1, perView - 1), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();

    // Video lightbox
    var lightbox = section.querySelector('[data-rc-lightbox]');
    var video = section.querySelector('[data-rc-lightbox-video]');
    var closers = section.querySelectorAll('[data-rc-lightbox-close]');

    function openLightbox(url) {
      if (!lightbox || !video) return;
      video.src = url;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      // Autoplay after a tick so the element is in the DOM
      setTimeout(function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked */ });
      }, 30);
    }

    function closeLightbox() {
      if (!lightbox || !video) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    closers.forEach(function (btn) { btn.addEventListener('click', closeLightbox); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
    });

    track.querySelectorAll('[data-rc-video-url]').forEach(function (media) {
      var url = media.getAttribute('data-rc-video-url');
      if (!url) return;
      media.addEventListener('click', function () { openLightbox(url); });
      media.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(url);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rc-section]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-rc-section]');
    if (sec) initCarousel(sec);
  });
})();
